'use client';

import { FORWARDED_PARAM_KEYS } from "components/shared/CustomLink";
import { getCookie } from 'utils/cookie';

const tracking_params = FORWARDED_PARAM_KEYS;

export const useForwardTrackingParams = (): ((
  urlString: string,
  productType: string,
  store: string,
) => string) => {
  return (urlString: string, productType: string, store: string) => {
    const url = urlString.split('?')[0];
    const currentParams = new URLSearchParams(window.location.search ?? '');
    const cartParams = new URLSearchParams(urlString.split('?')[1]);
    const trackingParams = new URLSearchParams();
    const finalTrackingParams = new URLSearchParams();
    trackingParams.set('product_type', productType);
    trackingParams.set('store', store);
    for (const [k, v] of currentParams.entries()) {
      if (tracking_params.includes(k)) {
        trackingParams.set(k, v);
      }
    }
    //add the existing search params
    for (const [k, v] of cartParams.entries()) {
      trackingParams.set(k, v);
    }
    // Read Meta attribution cookies for CAPI event matching
    try {
      const fbclid = getCookie('_uh_fbclid');
      if (fbclid) trackingParams.set('fbclid', String(fbclid));
      const fbp = getCookie('_fbp');
      if (fbp) trackingParams.set('_fbp', String(fbp));
      // getCookie() does not decode, but the value is written encoded.
      const rdtCid = getCookie('_uh_rdt_cid');
      if (rdtCid)
        trackingParams.set('rdt_cid', decodeURIComponent(String(rdtCid)));
    } catch (_) {
      // cookie read may fail in SSR or with restricted permissions
    }
    for (const [k, v] of trackingParams.entries()) {
      finalTrackingParams.set(k, v);
      if (k === 'email') finalTrackingParams.set(`checkout[email]`, v);
      finalTrackingParams.set(`attributes[${k}]`, v);
    }
    const newUrl = new URL(url);
    newUrl.search = finalTrackingParams.toString();
    return newUrl.href;
    // return `${new URL(urlString).toString()}&${trackingParams.toString()}`;
  };
};
